import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'Wiadomości e-mail',
  labels: {
    view_full_message: 'Zobacz pełną wiadomość',
    status: 'Status:',
    on: 'Wł.',
    off: 'Wył.',
    next_send: 'Następna wysyłka: {{date}}.',
  },
  descriptions: {
    welcome:
      'Wysyłany raz, gdy klient zapisze się na Twoje e-maile marketingowe, z wyjątkiem zapisów przez formularz w Twojej witrynie. Klient otrzymuje tylko jedną z wiadomości: Powitanie, Powitanie klubu członkowskiego lub Okazja startowa.',
    welcome_members_club:
      'Wysyłany raz, gdy ktoś zapisze się przez formularz w Twojej witrynie, a kod promocyjny za zapis nie jest skonfigurowany, lub dołączy do Twojej listy członków VIP. Klient otrzymuje tylko jedną z wiadomości: Powitanie, Powitanie klubu członkowskiego lub Okazja startowa.',
    storefront_promo:
      'Wysyłany raz, gdy ktoś zapisze się przez formularz w Twojej witrynie, a kod promocyjny za zapis jest skonfigurowany. E-mail zawiera osobisty kod promocyjny klienta.',
    launch_deal:
      'Wysyłany raz do zaimportowanych klientów, 30 minut po uruchomieniu Twojej restauracji. Klienci, którzy otrzymali już Powitanie lub Powitanie klubu członkowskiego, są pomijani.',
    we_miss_you:
      'Wysyłany do subskrybentów, których ostatnie zamówienie było ponad 45 dni temu. Sprawdzane każdego ranka; klient otrzymuje go co najwyżej raz na 45 dni.',
    happy_friday:
      'Wysyłany do wszystkich subskrybentów o 08:00 UTC w pierwszy piątek każdego parzystego miesiąca (luty, kwiecień, czerwiec, sierpień, październik, grudzień).',
    lazy_sunday:
      'Wysyłany do wszystkich subskrybentów o 08:00 UTC w pierwszą niedzielę każdego nieparzystego miesiąca (styczeń, marzec, maj, lipiec, wrzesień, listopad).',
    loyalty_program:
      'Wysyłana, gdy saldo cashbacku klienta osiągnie minimalną kwotę, którą może wydać. Klient otrzymuje ją maksymalnie raz na 30 dni.',
    you_might_also_like:
      'Wysyłany 3 dni po zamówieniu zawierającym co najmniej 2 takie same pozycje w cenie 6,00 lub wyższej, z polecaniem jednej z Twoich najpopularniejszych pozycji. Klient otrzymuje go co najwyżej raz na 30 dni.',
  },
  tiles: {
    sends_count: 'Wysłane wiadomości',
    delivery_rate: 'Wskaźnik dostarczenia',
    delivered_suffix: 'dostarczono',
    open_rate: 'Wskaźnik otwarć',
    opened_suffix: 'otwarto',
    click_rate: 'Wskaźnik kliknięć',
    clicked_suffix: 'kliknięto',
    spam_report_rate: 'Wskaźnik zgłoszeń spam',
    spam_reports_suffix: 'zgłoszenia',
    unsubscribe_rate: 'Wskaźnik rezygnacji',
    unsubscribes_suffix: 'rezygnacje',
  },
  toasts: {
    failed_to_update_status: 'Nie udało się zaktualizować statusu',
    failed_to_load_data: 'Nie udało się załadować danych',
  },

  preview_modal: {
    title: 'Podgląd szablonu',
    labels: {
      subject: 'Temat:',
      close: 'Zamknij',
    },
    toasts: {
      failed_to_load_data: 'Nie udało się załadować podglądu',
    },
    template_data: {
      recipient_name: '&lt;Imię&gt;',
    },
  },
};
